(function () {
  function initHover() {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const thumbItems = gallery.querySelectorAll('.product__thumbs-item.swiper-slide');
    if (!thumbItems.length) return;

    thumbItems.forEach((thumb) => {
      thumb.addEventListener('mouseenter', () => {
        const mediaPosition = parseInt(thumb.getAttribute('data-media-position'));
        if (isNaN(mediaPosition)) return;

        // Access the sliderInstance directly from the media-gallery custom element
        if (gallery.sliderInstance && gallery.sliderInstance.slider) {
          gallery.sliderInstance.slider.slideTo(mediaPosition - 1, 0, false);
        }
      });
    });
  }

  // Wait for media-gallery custom element to fully initialize
  window.addEventListener('load', () => {
    setTimeout(() => {
      initHover();
    }, 800);
  });

// Hide first slide from main gallery
window.addEventListener('load', () => {
  setTimeout(() => {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    if (gallery.sliderInstance && gallery.sliderInstance.slider) {
      const slider = gallery.sliderInstance.slider;

      // Skip slide index 0, start from index 1
      slider.on('beforeInit', () => {
        slider.activeIndex = 1;
      });

      // If currently on slide 0, jump to slide 1
      if (slider.activeIndex === 0) {
        slider.slideTo(1, 0, false);
      }

      // Prevent sliding back to index 0
      slider.on('slideChange', () => {
        if (slider.activeIndex === 0) {
          slider.slideTo(1, 0, false);
        }
      });
    }
  }, 10);
});

})();